/**
 * Region Model Interface
 * Framework-agnostic TypeScript interface
 */

export interface Region {
  region_id?: number;
  id?: number;
  region: string;
  region_name?: string;
  region_code?: string;
  created_at?: string;
  updated_at?: string;
  active?: number | boolean;
  program_id?: number;
}

export interface RegionFormData {
  id?: number;
  region_id?: number;
  region: string;
  region_name?: string;
}

export interface RegionApiResponse {
  data: {
    region: Region[];
  };
  message?: string;
  success?: boolean;
}
